import { render } from "./Admin.vue?vue&type=template&id=6acc21e7"
import script from "./Admin.vue?vue&type=script&lang=js"
export * from "./Admin.vue?vue&type=script&lang=js"
script.render = render

export default script